module.exports = __webpack_public_path__ + "img/mb-default.25c98bb2.svg";